import { createContext } from "react";

export const EngageContext = createContext({
    value:{},
    setValue :(value) =>{}

});